<template>
  <div>
    <v-sheet style="background-color: transparent" class="mx-auto">
      <v-slide-group elevation="10">
        <v-slide-item v-for="rental in newH" :key="rental.id">
          <div>
            <v-card
              class="shadow ma-4"
              min-height="380"
              width="370"
              color="grey lighten-4"
            >
              <v-img :aspect-ratio="16 / 9" :src="rental.Images[0]"></v-img>

              <v-card-text class="text-center">
                <span
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                >
                  Sold By: {{ rental.ListAgentFullName }}
                </span>

                <h3
                  class="display-1 font-weight-light blue--text mb-2 text-center"
                >
                  {{ rental.StreetNumber }}
                  {{ rental.StreetName }}
                  {{ rental.StreetSuffix }}
                </h3>
                <v-divider></v-divider>

                <v-chip class="mt-2"
                  ><i class="m-1 text-secondary fas fa-align-justify"></i
                  ><b class="mr-1">Square Feet: </b>
                  {{ rental.LivingAreaRange }}
                </v-chip>
              </v-card-text>
            </v-card>
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: { status: Boolean },
  data: () => ({
    home: "home",
    displayModal: false,
    showMessage: false,
    loading: false,
    search: "",
    price: "",
    bed: "",
    bath: "",
    newH: []
  }),

  created() {
    // this.newHomes();
  },

  methods: {
    redirectRental() {
      this.$router.push({ name: "rentals" });
    },

    openModal() {
      if (!sessionStorage.getItem("modal")) {
        this.displayModal = true;
      } else {
        this.redirectListing();
      }
    },

    redirectListing() {
      this.displayModal = false;
      this.$router.push({ name: "listings" });
    },

    register() {
      this.$router.push({ name: "Register" });
    },

    singleView(rental) {
      this.$router.push({
        name: "SingleIDX",
        params: { id: rental.ListingKeyNumeric, rental }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.pulse-button {
  box-shadow: 0 0 0 rgba(14, 118, 170, 0.7);
  -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
}
.pulse-button:hover {
  -webkit-animation: none;
  -moz-animation: none;
  -ms-animation: none;
  animation: none;
}

@-webkit-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-moz-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-ms-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}

.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 4px 16px;
}

#cards-container {
  overflow: hidden;
  margin: 20px;
}

.cards {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 99999px;
}

.card {
  /* Add shadows to create the "card" effect */
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  width: 235px;
  margin: 15px 7.5px;
}

.card:hover {
  -webkit-box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.card .img {
  max-width: 220px;
  height: 220px;
  display: inline-block;
}

#slide-left-container,
#slide-right-container {
  display: none;
}

#slide-left-container.active,
#slide-right-container.active {
  display: block;
  cursor: pointer;
}

.slide-left,
.slide-right {
  border-color: #fff;
  border-style: solid;
  height: 20px;
  width: 20px;
  margin-top: 30%;
}

.slide-left {
  border-width: 4px 0 0 4px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  margin-left: 40%;
}

.slide-right {
  border-width: 4px 4px 0 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin-left: 22%;
}
</style>
